/**
 * Service worker registration.
 *
 * The worker caches the **app shell only** — never session data (`ProductOverview.md` §4.8).
 * It is registered in production builds only, because a caching worker in front of Vite's dev
 * server makes every change a debugging session.
 */

export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
      // An unregistered worker costs a cold start, nothing more. Never block the app on it.
    });
  });
}
